<card #cardContainer
      [isCollapsible]="true"
      class="collapsible">
    <div class="card-header-content">
        <div class="title" (click)="menuToggleCard()">
            <fa-icon [icon]="iconUsers" *ngIf="bookingData.xType === 'group'"></fa-icon>
            {{this.labels.title}} {{bookingData.code}}

            <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
                {{this.bookingData.host | hostAlias | async}} <interface-flag [interface]="interface"></interface-flag>
            </ng-container>
        </div>
        <div class="flex">
            <ng-content select=".booking-information-hook"></ng-content>
            <booking-actions-menu [showBookingActions]="showBookingActions"
                                  [disableBookingActions]="disableBookingActions"
                                  [bookingData]="bookingData"
                                  (onQualityCheck)="onQualityCheck.emit()"
                                  (onIssue)="onIssue.emit()"
                                  (onCancel)="onCancel.emit()"
                                  (onVoid)="onVoid.emit()"
                                  (onUpdate)="onUpdate.emit()"
                                  (onGetVoucher)="onGetVoucher.emit()"
                                  (onModifyItinerary)="onModifyItinerary.emit()"
                                  (onAddServicesAbilityComputed)="onAddServicesAbilityComputed.emit($event)"
                                  (onAddServices)="onAddServices.emit()"></booking-actions-menu>
        </div>
    </div>
    <div class="card-body-content">
        <div class="booking-information" *ngIf="!actionLoading">
            <div class="column">
                <booking-status mode="label"
                                [status]="bookingData.xStatus"
                                [label]="labels.statutDossier"
                                [breakLine]="true"></booking-status>
            </div>
            <div class="column" *ngIf="type.isAir && (issueStatusStream | async) as statuses">
                <label *ngIf="issueStatus !== null">
                    <span class="break-line">{{ labels.issuance }}</span> <strong
                        [class]="insuanceStatus">{{ issueStatus }}</strong>
                </label>
            </div>

            <div class="column" *ngIf="midOfficeStatusStream | async as statuses">
                <label *ngIf="midOfficeDataStatus !== null">
                    <span class="break-line">{{ labels.internal }}</span> <strong>{{ midOfficeDataStatus }}</strong>
                </label>
            </div>


            <ng-container *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW">
                <div class="column"
                     *ngIf="type.isAir && (qualityCheckStatus === labels.qualityCheckStatusAnomalies || qualityCheckStatus === labels.qualityCheckStatusOk)">
                    <label>
                        <span class="break-line">{{ labels.qualityCheck }}</span>
                        <strong
                                [ngClass]="{ 'anomalies': qualityCheckStatus === labels.qualityCheckStatusAnomalies , 'ok': qualityCheckStatus === labels.qualityCheckStatusOk  }"
                                (click)="goToAnchor('qualityControl')"
                        >{{qualityCheckStatus}}
                        </strong>
                    </label>
                </div>
            </ng-container>

            <ng-container *permissionIf="bookingPermissions.SHARED_BOOKING_SAPEIG_BALANCE_VIEW">
                <div class="column" *ngIf="bookingData?.sapeigBalance?.details?.length">
                    <div *ngFor="let detail of bookingData?.sapeigBalance?.details">
                        <label>
                            <span class="break-line">{{sapeigStatusLabel.status}} </span><strong
                                [class]="detail.status">{{sapeigStatusLabel[detail.status]}}</strong>
                        </label>

                        <div *ngIf="detail.status === 'Partial'" class="inline">
                            <span class="price-label">{{labels.dueValue}}&nbsp;</span>
                            <price [value]="detail.due"
                                   [currency]="detail.currency"></price>
                            -{{detail.due | percentCompute:detail.totalExpected:true | percent:'2.2-2'}}
                            <span>&nbsp;/&nbsp;</span>

                            <span class="price-label">{{labels.totalExpectedValue}}&nbsp;</span>
                            <price [value]="detail.totalExpected"
                                   [currency]="detail.currency"></price>

                        </div>
                    </div>

                </div>
            </ng-container>


            <div class="column" *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW">
                <div class="price-container">
                    <div class="price-label">{{labels.totalCost}}</div>
                    <div class="price-content">
                        <price *ngIf="bookingTranslated.totalCost && showCostPricePermission"
                               [value]="bookingTranslated.totalCost.value"
                               [currency]="bookingTranslated.totalCost.currency"
                               type="big"></price>
                        <strong *ngIf="!bookingTranslated.totalCost || !showCostPricePermission"
                                class="undefined-data">{{ labels.undefinedPrice}}</strong>
                    </div>
                </div>
                <div *ngIf="bookingTranslated.totalRetail && showRetailPricePermission" class="price-container">
                    <div class="price-label">{{labels.totalRetail}}</div>
                    <div class="price-content">
                        <price [value]="bookingTranslated.totalRetail.value"
                               [currency]="bookingTranslated.totalRetail.currency"
                               type="big"></price>
                    </div>

                </div>
                <ng-container *ngIf="bookingTranslated.totalHistory?.issuedValue">
                    <div *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW"
                         class="price-container">
                        <div class="price-label">{{labels.totalIssued }}</div>
                        <div class="price-content">
                            <price [value]="bookingTranslated.totalHistory.issuedValue"
                                   [allowZeroValue]="true"
                                   [currency]="bookingTranslated.totalHistory.currency"
                                   type="large"></price>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="bookingTranslated.totalHistory?.usedValue">
                    <div *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW"
                         class="price-container">
                        <div class="price-label">{{labels.totalUsed}}</div>
                        <div class="price-content">
                            <price [value]="bookingTranslated.totalHistory.usedValue"
                                   [allowZeroValue]="true"
                                   [currency]="bookingTranslated.totalHistory.currency"
                                   type="large"></price>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="bookingTranslated.totalHistory?.pendingValue">
                    <div *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW"
                         class="price-container">
                        <div class="price-label">{{labels.totalPending}}</div>
                        <div class="price-content">
                            <price [value]="bookingTranslated.totalHistory.pendingValue"
                                   [allowZeroValue]="true"
                                   [currency]="bookingTranslated.totalHistory.currency"
                                   type="large"></price>
                        </div>
                    </div>
                </ng-container>

                <ng-container class="price-container" *permissionIf="'shared.air.carbonFootprint.show'">
                    <div *ngIf="type.isAir && carbonFootprint">
                        <carbon-footprint [alignWithPrice]="true" [carbonValue]="carbonFootprint"></carbon-footprint>
                    </div>
                </ng-container>
            </div>

        </div>
        <booking-time-line [bookingData]="bookingData"></booking-time-line>
        <ng-content></ng-content>
        <ng-container *permissionIf="sashaPermissions.SASHA_BOOKING_AIR_FARE_OPTIMISATION_USE">
            <fare-optimisation-summary *ngIf="fareOptimisation"
                                       [fareOptimisation]="fareOptimisation"
                                       [bookingSyscode]="bookingData.syscode"
                                       [booking]="bookingData.booking"
                                       [prices]="bookingData.booking?.priceArray">
            </fare-optimisation-summary>
        </ng-container>
    </div>

    <notification *ngIf="notificationTable.length"
                  [showCloseButton]="false"
                  [type]="errorNotificationType"
                  class="notification card-body-content">
        <div *ngFor="let line of notificationTable">
            <fa-icon [icon]="iconExclamationTriangle" class="notification-icon"></fa-icon>
            <label class="notification-label">{{line}}</label>

        </div>
    </notification>

</card>
